import useAuth from '../../component/useAuth';
import StudentTemplate from '../../component/StudentTemplate';
import { useEffect } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React, { useRef } from "react";

import { useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Loader from '../../component/Loader';
import { Radio } from "@mui/material";
import logo from "../../Assets/images/gif/danger.gif";

export default function Scrutiny() {

    const navigate = useNavigate();
    const isAuth = useAuth();

    if (isAuth === false) {
        navigate("/")
    }

    let { id } = useParams();
    const decodedID = atob(id);

    const { http } = Api();
    const [loading, setloading] = useState(false);
    const [selected, setSelected] = useState([]);
    const [question, setquestion] = useState([]);
    const [complaintes, setcomplaintes] = useState([]);
    const [scrutiny, setscrutiny] = useState([]);

    const [openAccordion, setOpenAccordion] = useState(0);
    const [isScrutinySaved, setIsScrutinySaved] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentScrutiny, setCurrentScrutiny] = useState(null);
    const [remainingCourses, setRemainingCourses] = useState([]);

    useEffect(() => {

        const getScrutinyStatusOfStudents = (id) => {

            http.get('/Student/getScrutinyStatusOfStudents', {
                params: {
                    exam_id: id
                }
            }).then(response => {

                if (response.data.applied_status === 'Completed' || response.data.applied_status === 'Not Registered') {

                    navigate(`/studentepapercopyview`);
                }
            }).catch(error => {

                console.log("no respond");
            })

        }



        if (decodedID) {
            getScrutinyStatusOfStudents(decodedID);
        }



    }, [decodedID]);


    //New API 

    useEffect(() => {

        if (!decodedID) {

            navigate("/studentdashboard");
        }
        else {


            http.get(`/Student/getActiveScrutiay`, {
                params: {
                    examid: decodedID
                }
            })
                .then(response => {

                    setscrutiny(response.data.activescrutiny);

                }).catch(error => {
                    console.log("No data found");

                    navigate("/studentdashboard");

                });


        }


    }, [isScrutinySaved])


    useEffect(() => {

        if (!decodedID) {

            navigate("/studentdashboard");
        }
        else {

            http.get(`/Student/getScrutinyComplaintsOfStudents`, {
                params: {
                    examid: decodedID
                }
            })
                .then(response => {

                    setSelected(prevState => {
                        const newState = { ...prevState };

                        response.data.result.forEach(course => {
                            // Use course_id as the key in the object
                            newState[course.course_id] = {
                                course_id: course.course_id,
                                mark_not_added: course.mark_not_added,
                            };
                        });

                        return newState;
                    });

                    setquestion(prevState => {
                        const newState = { ...prevState };

                        response.data.result.forEach(course => {
                            // Use course_id as the key in the object
                            newState[course.course_id] = {
                                questions_not_valued: course.questions_not_valued,
                            };
                        });

                        return newState;
                    });

                    setcomplaintes(prevState => {
                        const newState = { ...prevState };

                        response.data.result.forEach(course => {
                            // Use course_id as the key in the object
                            newState[course.course_id] = {
                                additional_description: course.additional_description,
                            };
                        });

                        return newState;
                    });
                    setIsScrutinySaved(false);


                })
                .catch(error => {
                    console.log("no data found");
                });
        }


    }, [])



    const handleCancel = () => {
        setIsModalOpen(!isModalOpen);
        // window.location.reload();
    }

    const handleNext = (index, revaluation_id, course_id, exam_id) => {

        setCurrentScrutiny({ index, revaluation_id, course_id, exam_id });
        if (!(question?.[course_id] || complaintes?.[course_id] || selected?.[course_id])) {
            toast.error("Please fill at least one of the fields to proceed");
        }
        else {
            setIsModalOpen(true);
        }

    };


    const confirmAndProceed = () => {
        if (!currentScrutiny) return;
        setIsModalOpen(false);
        setloading(true);
        const { index, revaluation_id, course_id, exam_id } = currentScrutiny;

        if (question?.[course_id] || complaintes?.[course_id] || selected?.[course_id]) {

            http.post('/Student/saveScrutinyComplaintsOfStudents', {


                revaluation_id: revaluation_id,
                exam_id: exam_id,
                marknotadded: selected[course_id]?.mark_not_added || null,
                course_id: course_id,
                questionsnotvalued: question[course_id]?.questions_not_valued || null,
                othercomplaints: complaintes[course_id]?.additional_description || null,


            })
                .then(response => {

                    if (response.data.status_code === "MSG1") {


                        if (response.data.applied_status === "Completed") {
                            toast.success("Completed Successfully");
                            setOpenAccordion(index + 1);
                            setTimeout(() => {
                                navigate("/studentepapercopyview");
                            }, 2000);

                        }
                        else {
                            toast.success("Scrutiny Complaints saved successfully");
                            setOpenAccordion(index + 1);
                            setIsScrutinySaved(!isScrutinySaved);
                        }

                        setloading(false);


                    }
                })
                .catch(error => {

                    setloading(false);

                    if (error.response && error.response.status === 500) {

                        toast.error("Something went wrong");

                    }
                });

        }
        else {

            toast.error("Please fill at least one of the fields to proceed");
        }
        setIsModalOpen(false);
    }

    console.log("setIsScrutinySaved:", isScrutinySaved);







    return (
        <>
            <ToastContainer />
            <StudentTemplate>

                {loading ? (

                    <Loader />
                ) : (
                    <>
                        <div className={`container ${isModalOpen ? 'blur-background' : ''}`}>
                            <div className="row">
                                <div className="col-lg-12 col-md-12 col-sm-12">
                                    <div className="card p-0">
                                        <div className="card-header d-flex justify-content-center">
                                            <h4 className="card-title m-0 text-black mobile1 ">
                                                Scrutiny Complaints
                                            </h4>

                                        </div>
                                        <div className="card-body p-0">

                                            <div class="container mt-4">

                                                {scrutiny.length > 0 && scrutiny.map((scrutinys, index) => (
                                                    <div className="accordion" id={`examAccordion-${index}`}>
                                                        <div className="accordion-item mb-3" >
                                                            <h2 className="accordion-header">
                                                                <button
                                                                    className={`accordion-button ${openAccordion === index ? '' : 'collapsed'} bg-primary mobilep`}
                                                                    type="button"
                                                                    onClick={() => setOpenAccordion(openAccordion === index ? -1 : index)}
                                                                    aria-expanded={openAccordion === index ? "true" : "false"}
                                                                    aria-controls={`collapsePart-${index}`}
                                                                    style={{ color: "white" }}
                                                                >
                                                                    <div className='mobilep'>{scrutinys.course_code} - {scrutinys.course_name}</div>
                                                                </button>
                                                            </h2>
                                                            <div
                                                                id={`collapsePart-${index}`}
                                                                className={`accordion-collapse collapse ${openAccordion === index ? 'show' : ''}`}

                                                            >


                                                                <div class="row p-3">
                                                                    <div class="col-md-12 col-lg-12 col-sm-12 ">
                                                                        <div class="mb-3">
                                                                            <label for="question1" class="mobilep">Marks of all the answers have not been
                                                                                precisely added.</label>
                                                                            <div className="mt-2 flex space-x-6">
                                                                                {[

                                                                                    { value: "yes", label: "Yes" },
                                                                                    { value: "no", label: "No" },

                                                                                ].map((option) => (
                                                                                    <label key={option.value} className="flex items-center space-x-2 cursor-pointer">
                                                                                        <Radio
                                                                                            checked={selected[scrutinys.course_id]?.mark_not_added === option.value}
                                                                                            onChange={() => setSelected(prevState => ({
                                                                                                ...prevState,
                                                                                                [scrutinys.course_id]: {
                                                                                                    course_id: scrutinys.course_id,
                                                                                                    mark_not_added: option.value
                                                                                                }
                                                                                            }))}
                                                                                            value={option.value}
                                                                                            color="primary"
                                                                                        />
                                                                                        <span className="text-gray-700 text-lg">{option.label}</span>
                                                                                    </label>
                                                                                ))}

                                                                            </div>
                                                                        </div>

                                                                        <div class="mb-3">
                                                                            <label for="question2" class="mobilep">If all answers were not valued, mention the
                                                                                question numbers.</label>
                                                                            <Select
                                                                                id="question2"
                                                                                isMulti
                                                                                options={Array.from({ length: 75 }, (_, i) => ({
                                                                                    value: i + 1,
                                                                                    label: `Question ${i + 1}`,
                                                                                }))}
                                                                                value={(question[scrutinys.course_id]?.questions_not_valued || []).map(q => ({
                                                                                    value: parseInt(q),
                                                                                    label: `Question ${parseInt(q)}`
                                                                                }))}

                                                                                // onFocus={() => {
                                                                                //     console.log("Current course ID:", scrutinys.course_id);
                                                                                //     console.log("Selected data for this course:", question[scrutinys.course_id]);
                                                                                // }}

                                                                                onChange={(selectedOptions) => {

                                                                                    const selectedValues = selectedOptions ? selectedOptions.map(option => option.value.toString()) : [];

                                                                                    const updatedSelected = {
                                                                                        ...question,
                                                                                        [scrutinys.course_id]: {
                                                                                            ...question[scrutinys.course_id],
                                                                                            questions_not_valued: selectedValues
                                                                                        }
                                                                                    };

                                                                                    // Update the state with the new selected values
                                                                                    setquestion(updatedSelected);
                                                                                }}
                                                                                placeholder="Choose..."
                                                                            />


                                                                        </div>


                                                                        <div class="mb-3">
                                                                            <label for="additionalDescription" class="form-label mobilep">Additional Description:</label>
                                                                            <textarea class="form-control" id="additionalDescription" rows="3"

                                                                                value={complaintes[scrutinys.course_id]?.additional_description || ''}

                                                                                onChange={(e) => {

                                                                                    const selectedValues = e.target.value;

                                                                                    const updatedSelected = {
                                                                                        ...complaintes,
                                                                                        [scrutinys.course_id]: {
                                                                                            ...complaintes[scrutinys.course_id],
                                                                                            additional_description: selectedValues
                                                                                        }
                                                                                    };

                                                                                    // Update the state with the new selected values
                                                                                    setcomplaintes(updatedSelected);
                                                                                }}

                                                                            >


                                                                            </textarea>
                                                                        </div>

                                                                        {scrutiny.length > index + 1 ? (
                                                                            <button type="button" class="btn btn-primary" onClick={() => handleNext(index, scrutinys.id, scrutinys.course_id, scrutinys.examid)}>Save & Next</button>
                                                                        ) : (
                                                                            <button type="button" class="btn btn-primary" onClick={() => handleNext(index, scrutinys.id, scrutinys.course_id, scrutinys.examid)}>Save</button>
                                                                        )}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                ))}



                                            </div>
                                            <div className="m-10 mobile text-center">
                                                <p className='mobile' >Note: No dispute regarding marks already awarded for answers shall be entertained at the scrutiny.</p>
                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                        </div>

                        {isModalOpen && (
                            <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-modal="true">
                                <div className="modal-dialog modal-dialog-centered" role="document">
                                    <div className="modal-content">



                                        <div className="modal-header bg-light border-bottom">
                                            <div className="d-flex align-items-center">
                                                <img src={logo} alt="Logo" style={{ width: '40px', height: '36px', marginRight: '10px' }} />
                                                <h5 className="modal-title fw-bold m-0 text-balck" id="paymentConfirmationModalLabel" style={{ color: 'black' }}>Save Confirmation</h5>
                                            </div>
                                            <button type="button" className="btn-close" onClick={handleCancel} aria-label="Close"></button>
                                        </div>


                                        <div className="modal-body">

                                            <p className="text-center text-black fw-bold ">Are you sure you want to proceed to Save?</p>
                                            <div className="alert alert-secondary border">
                                                <p className="mb-0"><strong>Important:</strong> This is a one-time application for the selected course. Once submitted, this course cannot be edited and will no longer appear in the list. Do you want to continue?</p>
                                            </div>



                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="close-btn-stl " onClick={handleCancel}>Close</button>
                                            <button type="button" className="btn btn-primary px-4" onClick={confirmAndProceed}>Proceed</button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </>
                )}
            </StudentTemplate >
        </>
    );
}
